import { API_G_040_HATCHU_CONFIRM, API_G_DOWNLOAD_FILE } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero, downloadFile } from '@/utils/utils';
import type { Module } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export type G_040 = {
    list: any;
};
  
const g_040: Module<G_040, unknown> = {
  namespaced: true,
  state() {
    return {
      list: [],
    };
  },
  mutations: {
    SET_LIST(state, payload: []) {
      state.list = payload;
    },
    RESET_DATA(state) {
      state.list = [];
    },
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    async getHatchuConfirmList({ commit }, params) {
      try {
        const res = await axios({
          url: API_G_040_HATCHU_CONFIRM,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        let hatchuConfirmList = [];
        if (res.data.responseData && res.data.responseData.length > 0)
          hatchuConfirmList = res.data.responseData.map(
            (item: any, index: any) => {
              return { id: index, ...item };
            }
          );
        commit('SET_LIST', hatchuConfirmList);
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getHatchuConfirmList error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async getHatchuConfirmItem(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_040_HATCHU_CONFIRM}/${params.hatchuJigyoshoCd}/${params.hatchuEntryYmd}/${params.hatchuNo}/${params.hatchuShuseiCount}`,
          method: 'GET',
          params: params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getHatchuConfirmItem error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async getRireki(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_040_HATCHU_CONFIRM}/rireki`,
          method: 'GET',
          params: params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getRireki error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putHatchuConfirm(_ctx, data) {
      try {
        const res = await axios({
          url: API_G_040_HATCHU_CONFIRM,
          method: 'PUT',
          data
        });

        return res;
      } catch (err) {
        console.log('call api putHatchuConfirm error.');
        console.log(err);
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async downloadFile({}, params) {
      const res = await axios({
        url: API_G_DOWNLOAD_FILE,
        params: removeBlankOrNullOrZero(params),
        method: 'GET',
      });
      const dataUri = res.data.responseData.dataUri;
      if (dataUri) {
        const fileName = decodeURI(params.s3Url).split('/');
        downloadFile(dataUri, fileName[fileName.length - 1]);
      }
      return res;
    },
    // eslint-disable-next-line no-empty-pattern
    async getCsvData({}, data) {
      const res = await axios({
        url: `${API_G_040_HATCHU_CONFIRM}/csv`,
        data,
        method: 'PUT',
      });
      return res;
    },
    resetData({ commit }) {
      commit('RESET_DATA');
    },
    async putHatchushoIkkatsu(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_040_HATCHU_CONFIRM}/hatchushoIkkatsu`,
          method: 'PUT',
          data: params,
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putHatchushoIkkatsu error.');
        console.log(err);
      }
    },
  },
};

export default g_040;
